<img [src]="getIconSource(status)" alt="WIFI" id="wifi-icon" />
